// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* center layout fix */
.Report-frame-3 {
  background-color: #F8FAFC;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 2%;
  text-align: center;
  gap: 2rem;
}

.assessments{
    padding-bottom: 1rem;
}

/* chart + audio center stack */
.assessment-visual-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 900px;
  text-align: center;
  margin: 0 auto;
}

.assessment-chart-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/* info icon */
.assessment-info-icon {
  margin-top: 16px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-button {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 20px;
  color: #000;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.info-button:hover {
  transform: scale(1.1);
  opacity: 0.7;
}

/* audio section */
.assessment-audio-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 12px;
  text-align: center;
}

.assessment-play-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 14px;
  height: 56px;
  border-radius: 8px;
  border: 1px solid #0A5B42;
  background: linear-gradient(180deg, #0C8F63 0%, #0A7253 103.57%);
  color: #FFF;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.assessment-audio-player {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.assessment-audio-player-inner {
  width: 100%;
  max-width: 900px;
}

/* responsive */
@media (max-width: 768px) {
  .Report-frame-3 {
    flex-direction: column;
    align-items: center;
  }
  .assessment-visual-block {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .assessment-play-button {
    width: 100%;
    height: 48px;
    font-size: 14px;
  }
  .info-button {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Reports/AssessmentTemplateAudio.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;IACI,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gEAAgE;EAChE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* center layout fix */\n.Report-frame-3 {\n  background-color: #F8FAFC;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  padding: 2%;\n  text-align: center;\n  gap: 2rem;\n}\n\n.assessments{\n    padding-bottom: 1rem;\n}\n\n/* chart + audio center stack */\n.assessment-visual-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 900px;\n  text-align: center;\n  margin: 0 auto;\n}\n\n.assessment-chart-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n/* info icon */\n.assessment-info-icon {\n  margin-top: 16px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.info-button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 20px;\n  color: #000;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.info-button:hover {\n  transform: scale(1.1);\n  opacity: 0.7;\n}\n\n/* audio section */\n.assessment-audio-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 12px;\n  text-align: center;\n}\n\n.assessment-play-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 14px;\n  height: 56px;\n  border-radius: 8px;\n  border: 1px solid #0A5B42;\n  background: linear-gradient(180deg, #0C8F63 0%, #0A7253 103.57%);\n  color: #FFF;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.assessment-audio-player {\n  margin-top: 8px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.assessment-audio-player-inner {\n  width: 100%;\n  max-width: 900px;\n}\n\n/* responsive */\n@media (max-width: 768px) {\n  .Report-frame-3 {\n    flex-direction: column;\n    align-items: center;\n  }\n  .assessment-visual-block {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .assessment-play-button {\n    width: 100%;\n    height: 48px;\n    font-size: 14px;\n  }\n  .info-button {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
